import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from './theme-provider';
import { cn } from '@/lib/utils';

const OPTIONS = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'dark', icon: Moon, label: 'Dark' },
  { value: 'system', icon: Monitor, label: 'System' },
] as const;

/** Segmented light / dark / system switcher. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-1 rounded-xl neo-inset p-1 bg-transparent">
      {OPTIONS.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          title={label}
          aria-label={label}
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-lg transition-all font-bold neo-interactive',
            theme === value
              ? 'bg-[var(--color-primary)] text-[var(--color-primary-content)] neo'
              : 'text-muted hover:text-theme opacity-70 hover:opacity-100',
          )}
        >
          <Icon className="h-4 w-4" />
        </button>
      ))}
    </div>
  );
}
